/* TBET — Unstick the collection meta bar once the user has scrolled past
 * the product grid. By default it's position: sticky and follows the user
 * for the entire page, including the category cards and footer (looks weird
 * — "OVERSIZE SHIRTS · 028 PIECES" still pinned while looking at the footer).
 *
 * This script watches the bottom of the product grid and toggles a
 * `tbet-collection-meta--past-grid` class on the meta section when the
 * grid's bottom edge has scrolled past the meta bar's bottom edge.
 */
(function () {
  'use strict';

  function init() {
    var meta = document.querySelector('.tbet-collection-meta-section');
    var grid =
      document.querySelector('#product-grid') ||
      document.querySelector('.collection .product-grid') ||
      document.querySelector('section[id*="product-grid"]') ||
      document.querySelector('section[id*="main-collection-product-grid"]');

    if (!meta || !grid) return;

    function update() {
      var gridBottom = grid.getBoundingClientRect().bottom;
      var metaHeight = meta.getBoundingClientRect().height || 36;
      // When the bottom of the grid has scrolled above the bottom edge of
      // the (sticky) meta bar, unstick — let it scroll away with the page.
      if (gridBottom < metaHeight + 8) {
        meta.classList.add('tbet-collection-meta--past-grid');
      } else {
        meta.classList.remove('tbet-collection-meta--past-grid');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
